import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";

// @ts-ignore
export const DrawerHeaderStyled = styled(Box, {
  shouldForwardProp: (prop: { open: boolean }) => !prop.open,
  // @ts-ignore
})(({ theme, open }) => ({
  ...theme.mixins.toolbar,
  display: "flex",
  alignItems: "center",
  justifyContent: open ? "flex-start" : "center",
  paddingLeft: theme.spacing(open ? 3 : 0),
  paddingRight: theme.spacing(3),
}));

export const LogoLink = styled(Link)({
  display: "flex",
  alignItems: "center",
});
